import { jsx as _jsx } from "react/jsx-runtime";
import * as styles from "./AssignmentChip.css.js";
// A tiny labelled pill marking who a packing item is for (design system: `core/Tag`).
// Distinct from `Badge` — smaller, tint-filled, and semantic to sharing; and distinct
// from `Tag`, which carries a user-defined free-text label (T29).
export const AssignmentChip = ({ variant, children }) => (_jsx("span", { className: [styles.base, styles.variant[variant]].join(" "), children: children ?? variant }));
//# sourceMappingURL=AssignmentChip.js.map